import {
  CAMERA_STATUS_CHANGE,
  MIXER_ATTENDEES_CAMERA_STATUS_CHANGE
} from 'store/eventConstants';
import { updateProgramByCameraSource } from 'actions/Broadcast';
import { BROADCAST_SET_DESIRED_ATTENDEE_CAMERA_STATUS } from 'actions/Types';
import { getProgramLayers } from 'utils/broadcastSourceHelper';
import { debounce } from 'underscore';
import { DEBOUNCE_PROGRAM_UPDATES } from '@studio/constants/SocketEvents';

export default (attendeeId, isCameraOn) => {
  return (dispatch, getState, socket) => {
    const {
      broadcast,
      program,
      attendeeCameraStatus,
      meeting: { attendeeResponse }
    } = getState();
    const { _id: broadcastId } = broadcast || {};
    const currentChimeAttendeeId = attendeeResponse?.Attendee.AttendeeId;
    const action = {
      type: BROADCAST_SET_DESIRED_ATTENDEE_CAMERA_STATUS,
      request: async () => {
        const payload = {
          attendeeId,
          isCameraOn,
          broadcastId
        };
        let mixerPayload = {
          broadcastId,
          attendeesCameraStatus: {
            ...attendeeCameraStatus,
            [attendeeId]: isCameraOn
          }
        };
        // Single debounced call that emits both events
        debouncedCameraStatusChange(socket, payload, mixerPayload);

        return Object.create(null);
      },
      payload: { attendeeId, isCameraOn, currentChimeAttendeeId }
    };

    dispatch(action);
    // see if source is in program layer
    if (program) {
      const [layerSource] = getProgramLayers(program).filter(
        layer => layer.source.value === attendeeId
      );
      // If source is in Program, update the program.
      if (layerSource) {
        const attendeeIdMap = {};
        attendeeIdMap[attendeeId] = attendeeId;
        dispatch(updateProgramByCameraSource(attendeeIdMap));
      }
    }
  };
};

const debouncedCameraStatusChange = debounce(
  (socket, payload, mixerPayload) => {
    socket.emit(CAMERA_STATUS_CHANGE, payload);
    // We send this to the mixer view to set all states.
    // mixer view in the cloud tends not to have the updated state.
    socket.emit(MIXER_ATTENDEES_CAMERA_STATUS_CHANGE, mixerPayload);
  },
  DEBOUNCE_PROGRAM_UPDATES
);
